export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img5-59e469fa2d7791a013f1b747e64056bd.png";